exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_modalWrap_2254Y {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.4);\n  z-index: 999;\n  justify-content: center;\n  align-items: center;\n}\n", ""]);

// Exports
exports.locals = {
	"modalWrap": "index_modalWrap_2254Y"
};